import gql from 'graphql-tag'

export const GetPlaidLink = gql`
    query GetPlaidLink {
        getConnectionLink(accountProvider: PLAID) {
            expiration
            link_token
            request_id
            status_code
        }
    }
`
